// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DatapointMetadataFromJSON(json) {
    return {
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}
export function DatapointMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'metadata': value.metadata,
        'id': value.id,
    };
}
